module.exports = __webpack_public_path__ + "img/5-full-lg.d6af5acf.jpg";